import { GenericBomGroup, GenericBomOutput } from "fond/types";
import { sum } from "fond/utils";

import { apiSlice } from "./apiSlice";

type RawBomGroup = Omit<GenericBomGroup, "total">;
interface RawBomOutput {
  groups: RawBomGroup[];
}

/**
 * BOM API Slice
 */
export const bomSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getBomTemplateCategories: build.query({
      query: () => `/v2/bom-template-categories`,
    }),
    getVersionBom: build.query<GenericBomOutput, string>({
      query: (versionId: string) => `/v2/versions/${versionId}/bom`,
      // Add group and overall totals to the response
      transformResponse: (response: RawBomOutput): GenericBomOutput => {
        const groups = response.groups.map((group) => ({
          ...group,
          total: sum(group.ruleOutput.map((rule) => parseFloat(rule.total))),
        }));
        return {
          groups,
          total: sum(groups.map((group) => group.total)),
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetBomTemplateCategoriesQuery, useGetVersionBomQuery } = bomSlice;
